import { render, staticRenderFns } from "./CategoryAssetComponent.vue?vue&type=template&id=091e67e4&scoped=true&"
import script from "./CategoryAssetComponent.vue?vue&type=script&lang=js&"
export * from "./CategoryAssetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091e67e4",
  null
  
)

export default component.exports